<!--
  ILES doplňková mapová nástrojová nabídka 
Nabídka s výběrem vrstve s informacemi o lese
Konfigurace je v souboru MapOt_Iles.json
 - Pracuje se se třemi vrstvy
    - "Uhul_iles" - typ "LayerGroup", sdružuje následující dvě vrsty a je vidět v legendě
         - tato vrstva musí být nakonfigurována v projektu - MapCompositionProject.json
    - "Uhul_iles_tile" - typ "Url", je vidět v menších měřítkách
    - "Uhul_iles_wfs" - typ "wfs", je vidět v větších měřítkách
-->
<template>

  <div class="d-flex flex-row" v-if="IsInit">

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="MapPnlGrdItem elevation-5" width="40" min-width="40" min-height="40" color="info" v-bind="attrs"
          v-on="on" @click="MapLayerLegendDynamicSet()">
          <v-icon>mdi-map-legend</v-icon>
        </v-btn>
      </template>
      <span class="">Legenda</span>
    </v-tooltip>

    <v-card width="288" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="IlesList" v-model="VybIles"
        item-text="Name" return-object dense hide-details="true" background-color="info" height="40">
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-bind="attrs" v-on="on">
            <v-list-item-avatar color="white" tile size="52">
              <v-img :src="AssetsUrl + '/img/map/mapa_Uhul_Iles_' + item.id + '.png'" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.Name"></v-list-item-title>
              <v-list-item-subtitle v-text="item.Popis" />
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-overflow-btn>
    </v-card>

    <v-card width="120" color="transparent" flat>
      <v-overflow-btn class="MapPnlGrdItem elevation-5 u_v-autocomplete " :items="VybIles.Rocnik" v-model="VybRok" dense
        hide-details="true" height="40" background-color="info">
      </v-overflow-btn>
    </v-card>

    <Teleport to="#MapLayerLegendDynamicObj" v-if="ViewLeg">

      <div v-if="MapScale < VybIles.Legenda.EditableMinScale">

        <v-tooltip left v-if="MapScale < VybIles.Legenda.EditableMinScale">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab small absolute right class="mr-3" color="info"
              @click="VybLegListSelectAll()">
              <v-icon v-if="VybLegList.length == 0">mdi-expand-all</v-icon>
              <v-icon v-else color="">mdi-collapse-all</v-icon>
            </v-btn>
          </template>
          <span v-if="VybLegList.length == 0">Vybrat vše</span>
          <span v-else>Odvybrat vše</span>
        </v-tooltip>

        <!-- Legenda s výběrem ( zobrazeno v měřítku pod VybIles.Legenda.EditableMinScale) -->
        <v-list dense color="transparent">
          <v-list-item-group multiple v-model="VybLegList" color="primary">
            <template v-for="(item) in VybIles.Legenda.Seznam" >

              <v-list-item v-if="(typeof item.RocnikPodminka == 'undefined') ||
                (VybRok >= item.RocnikPodminka.RocnikMin &&
                  VybRok <= item.RocnikPodminka.RocnikMax)" :key="item.Kod" :value="item.Kod">

                <!-- Se šrafou -->
                <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
                  <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                    <defs>
                      <!-- definice výplně - šrafy -->
                      <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth"
                        :height="item.Srafa.PatternHeight" patternUnits="userSpaceOnUse">
                        <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                          :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                        </path>
                      </pattern>
                    </defs>
                    <!-- případná barva podkladu -->
                    <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                    <!-- výplň - šrafa -->
                    <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
                  </svg>
                </v-list-item-avatar>

                <!-- Bez šrafy -->
                <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

                <v-list-item-title v-text="item.Popis" class="white--text"></v-list-item-title>
              </v-list-item>

            </template>
          </v-list-item-group>
        </v-list>

      </div>

      <div v-else>
        <!-- Legenda bez výběru ( zobrazeno v měřítku nad VybIles.Legenda.EditableMinScale)  -->
        <v-list dense color="transparent">
          <template v-for="item in VybIles.Legenda.Seznam">

            <v-list-item v-if="(typeof item.RocnikPodminka == 'undefined') ||
              (VybRok >= item.RocnikPodminka.RocnikMin &&
                VybRok <= item.RocnikPodminka.RocnikMax)" :key="item.Kod">

              <!-- Se šrafou -->
              <v-list-item-avatar v-if="item.Srafa" class="my-1" rounded color="transparent">
                <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg" :color="item.Barva">
                  <defs>
                    <!-- definice výplně - šrafy -->
                    <pattern :id="'pt_' + item.Kod" :width="item.Srafa.PatternWidth" :height="item.Srafa.PatternHeight"
                      patternUnits="userSpaceOnUse">
                      <path :d="item.Srafa.Pathd" style="stroke:currentColor"
                        :style="{ 'stroke-width': item.Srafa.PathdStyleStrokeWidth }">
                      </path>
                    </pattern>
                  </defs>
                  <!-- případná barva podkladu -->
                  <rect width="100%" height="100%" :fill="item.Srafa.BarvaPodklad" v-if="item.Srafa.BarvaPodklad" />
                  <!-- výplň - šrafa -->
                  <rect width="100" height="100" :fill="'url(#pt_' + item.Kod + ')'" />
                </svg>
              </v-list-item-avatar>

              <!-- Bez šrafy -->
              <v-list-item-avatar v-else class="my-1" rounded :color="item.Barva" />

              <v-list-item-title v-text="item.Popis"></v-list-item-title>
            </v-list-item>

          </template>
        </v-list>

      </div>

    </Teleport>

    <Teleport to="#MapUserSettingsObj">

      <v-switch dense class="mt-0" v-model="MapUserSettings_WfsHoverable" color="accent"
        :label="MapUserSettings_WfsHoverable ? 'Informace o objektu se zobrazují automaticky pod kurzorem.' : 'Informace o objektu se zobrazují po kliknutí.'">
      </v-switch>

    </Teleport>

  </div>
</template>

<script>
import AppIles from "../../../assets/MapOt_Iles.json";
import { eq, or, literal, property, toFeaturePredicate } from "@luciad/ria/ogc/filter/FilterFactory";

export default {

  components: {
    Teleport: () => import("vue2-teleport")
  },


  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // Mapa (Luciad)
    MAP: Object,
    // Měřítko vztažené k rovníku
    MapScale: null,
    // Mapové vrstvy
    MapLegendLayers: null,
    // Viditelnost legendy
    MapLayerLegend_view: null,
    // Jméno zobrazené dynamické legendy
    MapLayerLegendDynamic_content: {},
  },

  data() {
    return {
      // Jestli je nástroj inicializován
      IsInit: false,
      // Seznam vrstev
      IlesList: [],
      // Vybraná vrstva
      VybIles: {
        "id": "",
        "Name": "",
        "Popis": "",
        "Rocnik": [],
        "Legenda": [],
      },
      // Vybraný rok
      VybRok: null,

      // Vybrané prvky vybrané legendy
      VybLegList: [],

      // Viditelnost legendy
      ViewLeg: false,

      // Jméno legendy
      MapLayerLegendDynamic_contentName: "MapOT_Iles_legend",
      // Informace o objektu automaticky pod kurzorem nebo na kliknutí
      MapUserSettings_WfsHoverable: true,


    };
  },



  computed: {
    // Vrstva LayerGroup z mapy určené pro ILES
    MapLayer_Uhul_iles: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_iles");
    },
    // Podřízená vrstvy - tile
    MapLayer_Uhul_iles_tile: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_iles_tile");
    },
    // Podřízená vrstvy - wfs
    MapLayer_Uhul_iles_wfs: function () {
      return this.MapLegendLayers.find((item) => item.id == "Uhul_iles_wfs");
    },

    // Tile vrstva - baseURL
    MapLayer_Uhul_iles_tile_baseURL: function () {
      return AppIles.MapLayers.Uhul_iles_tile.url.url + this.VybIles.id + "/" + this.VybRok + "/{z}/{-y}/{x}.webp";
    },
    // wfs vrstva - layers
    MapLayer_Uhul_iles_wfs_Wfslayers: function () {
      return "gmgml:iles_" + this.VybIles.id + "_" + this.VybRok;
    },
    // wfs vrstva - layers
    MapLayer_Uhul_iles_wfs_Painter: function () {
      return "FP_Iles_" + this.VybIles.id;
    },

    // wfs vrstva - filter podle výběru
    MapLayer_Uhul_iles_wfs_Filter: function () {
      if (this.VybIles.Legenda.Seznam.length == this.VybLegList.length) {
        // Všechny položky
        return null

      } else if (this.VybLegList.length == 0) {
        // žádná položka - rovno neexistující hodnotě
        return toFeaturePredicate(eq(property(this.VybIles.Legenda.Polozka), literal('xxxxxxxx')));

      } else if (this.VybLegList.length == 1) {
        // Jedna položka
        return toFeaturePredicate(eq(property(this.VybIles.Legenda.Polozka), literal(this.VybLegList[0])));

      } else {

        var _this = this;
        var filters = this.VybLegList.map(function (l) {
          return (eq(property(_this.VybIles.Legenda.Polozka), literal(l)))
        })

        return toFeaturePredicate(or(...filters));
      }
    },




  },

  watch: {
    // Inicializace
    IsInit: function () {
      // console.log("IsInit");
      // console.log(value);
      this.MapUserSettingsButtonView(true);

    },


    // Změna druhu mapy
    VybIles: function (value) {
      //console.log("zMĚNA - VybIles");

      this.MapLayer_Uhul_iles.label = value.Name;
      this.MapLayer_Uhul_iles.legend.image = "img/map/mapa_Uhul_Iles_" + value.id + ".png";

      // Změna roku vyvolá změnu mapy, když se rok nezmění, je třeba změnu vyvolat ručně
      if (this.VybRok != value.Rocnik[0]) {
        this.VybRok = value.Rocnik[0];
      } else {
        this.ZmenaMapy();
      }

      // Legenda
      // Vybrat vše v legendě
      this.VybLegList = this.VybIles.Legenda.Seznam.map(function (l) {
        return l.Kod
      })

      // Zobrazení legendy - když existuje a je zobrazená
      if ((this.VybLegList.length > 1) && this.MapLayerLegend_view) {
        this.MapLayerLegendDynamicSet()
      }



    },

    // Změna roku
    VybRok: function (value) {
      //console.log("zMĚNA - VybRok");

      this.MapLayer_Uhul_iles.labelsub = value;
      // Změna roku znamená vždy změnu mapy
      this.ZmenaMapy();
    },

    // Změna zobrazení jednotlivých objektů v legendě
    VybLegList: function () {

      this.MapLayer_Uhul_iles_wfs.layer.filter = this.MapLayer_Uhul_iles_wfs_Filter;

    },

    // Změna zobrazení vlastní legendylegendy
    MapLayerLegendDynamic_content: function (value) {
      // console.log("MapLayerLegendDynamic_content")
      // console.log(value)

      if (value == this.MapLayerLegendDynamic_contentName) { this.ViewLeg = true } else { this.ViewLeg = false }

    },

    // Změna informací pod kursorem
    MapUserSettings_WfsHoverable: function (value) {
      // console.log("MapUserSettings_WfsHoverable")
      // console.log(value)

      AppIles.MapLayers.Uhul_iles_wfs.featureOptions.hoverable = value;
      AppIles.MapLayers.Uhul_iles_wfs.featureOptions.selectable = !value;

      this.MapLayer_Uhul_iles_wfs.layer.hoverable = value;
      this.MapLayer_Uhul_iles_wfs.layer.selectable = !value;

    },

  },

  methods: {
    // Nová mapová vrstva - volá se funkce v nadřazeném objektu
    MapLegendNewLayer: function (vMapLayerInstr, vMapLayerVisible) {
      this.$emit('MapLegendNewLayer', vMapLayerInstr, vMapLayerVisible);
    },

    // Zobrazení dynamické mapové legendy - volá se funkce v nadřazeném objektu
    MapLayerLegendDynamicSet: function () {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapLayerLegendDynamicSet', this.MapLayer_Uhul_iles.id, this.VybIles.Name, this.MapLayerLegendDynamic_contentName);
    },

    // Viditelnost tlačítka pro dialog s nastavením
    MapUserSettingsButtonView: function (value) {
      //console.log("MapLayerLegendDynamicSet")
      this.$emit('MapUserSettingsButtonView', value);
    },


    // Vybrat vše v legendě (když počet nula) jina odvybrat vše
    VybLegListSelectAll: function () {
      if (this.VybLegList.length == 0) {
        this.VybLegList = this.VybIles.Legenda.Seznam.map(function (l) {
          return l.Kod
        })
      } else {
        this.VybLegList = []
      }

    },





    // Funkce při změně mapy
    ZmenaMapy: function () {
      if (this.IsInit) {
        //console.log("zMĚNA mapy");

        // Změna tile
        //console.log("Změna tile")
        //console.log(this.MapLayer_Uhul_iles_tile.layer.scaleRange.max)
        //console.log(1 / this.VybIles.Map.IlesTileMaxScale)
        // Když se mění měřítko, je třeba vytvořit vrstvu zcela novou, není jiná možnost jak změnit měřítko
        if (this.MapLayer_Uhul_iles_tile.layer.scaleRange.max == (1 / this.VybIles.Map.IlesTileMaxScale)) {
          // Pouze změna adresy
          //console.log("Pouze změna adresy")
          this.MapLayer_Uhul_iles_tile.layer.model.baseURL = this.MapLayer_Uhul_iles_tile_baseURL

        } else {
          // vytvoření nové vrstvy
          //console.log("vytvoření nové vrstvy")

          // Uložení nastaveného stylu
          var vRStyle = this.MapLayer_Uhul_iles_tile.layer.rasterStyle

          var TilePredpis = AppIles.MapLayers.Uhul_iles_tile;
          TilePredpis.url.param = this.VybIles.id + "/" + this.VybRok + "/";
          TilePredpis.maxScale = this.VybIles.Map.IlesTileMaxScale;
          this.MapLegendNewLayer(TilePredpis, true)

          // Vložení stylu
          this.MAP.layerTree.whenReady().then(() => {
            this.MapLayer_Uhul_iles_tile.layer.rasterStyle = vRStyle
          })

        }


        // Změna wfs - nová vrstva
        // Zatím neexistuje způsob, jak vrstvu pouze upravit
        var WfsPredpis = AppIles.MapLayers.Uhul_iles_wfs;
        WfsPredpis.opacity = this.MapLayer_Uhul_iles.opacity;
        WfsPredpis.wfs.layers = this.MapLayer_Uhul_iles_wfs_Wfslayers;
        WfsPredpis.featureOptions.painter = this.MapLayer_Uhul_iles_wfs_Painter;
        WfsPredpis.minScale = this.VybIles.Map.IlesWfsMinScale;
        this.MapLegendNewLayer(WfsPredpis, true)
        //console.log(WfsPredpis)
      }
    },


  },

  mounted() {
    // První spuštění nástroje
    //console.log("ILES start");

    // Základní nastavení - 
    this.IlesList = AppIles.IlesList;
    // Načtení první vrstvy ze seznamu
    this.VybIles = this.IlesList[0];

    // Vybrat vše v legendě
    this.VybLegList = this.VybIles.Legenda.Seznam.map(function (l) {
      return l.Kod
    })

    // Vytvoření podřízených vrstev - tile a wfs
    // Změna parametrů předpisů podle první vrstvy
    AppIles.MapLayers.Uhul_iles_tile.url.param = AppIles.IlesList[0].id + "/" + AppIles.IlesList[0].Rocnik[0] + "/";
    AppIles.MapLayers.Uhul_iles_tile.maxScale = AppIles.IlesList[0].Map.IlesTileMaxScale;
    AppIles.MapLayers.Uhul_iles_wfs.wfs.layers = "gmgml:iles_" + AppIles.IlesList[0].id + "_" + AppIles.IlesList[0].Rocnik[0];
    AppIles.MapLayers.Uhul_iles_wfs.featureOptions.painter = "FP_Iles_" + AppIles.IlesList[0].id;
    AppIles.MapLayers.Uhul_iles_wfs.minScale = AppIles.IlesList[0].Map.IlesWfsMinScale;

    // Nové vrstvy
    this.MapLegendNewLayer(AppIles.MapLayers.Uhul_iles_tile, true)
    this.MapLegendNewLayer(AppIles.MapLayers.Uhul_iles_wfs, true)

    // Objekt aktivován
    this.MAP.layerTree.whenReady().then(() => { this.IsInit = true; })

    // // Legenda vrstvy
    // this.MapLayerLegendDynamicAdd()

  },
};
</script>